import { Skeleton } from 'antd'
import Styles from './ExternalResourceLoadingState.module.scss'

export const ExternalResourceLoadingState = () => {
  return (
    <>
      <div className={Styles.loadingStateContainer}>
        <Skeleton active paragraph={{ rows: 5, width: 300 }} title={false} />
        <Skeleton active paragraph={{ rows: 1, width: 171 }} title={false} />
      </div>
    </>
  )
}
